import React from "react";
import {Announcement} from "../announcement/Announcement";

const facebookPage = 'https://www.facebook.com/TTCBartMerksem';

export const Home = () => {
    return (
        <>
            <header className={'ttc-hero'}>
                <div className={'ttc-hero-copy'}>
                    <span className={'ttc-badge'}>Erkende sportclub</span>
                    <h1 className={'ttc-headline'}>De tofste club uit Merksem en omstreken!</h1>
                    <p className={'ttc-lead'}>Welkom op onze vernieuwde website. Hier kan u alle info terugvinden over
                        onze club.</p>
                </div>
                <div className={'ttc-hero-photo'}>
                    <img src={'/tafeltennis.jpg'} alt={'Actiefoto van de club'}/>
                </div>
            </header>

            <div className={'ttc-content'}>
                <section className={'ttc-news'}>
                    <h2 className={'ttc-section-title'}>Nieuws</h2>
                    <Announcement featured
                                  title={'Kampioenschap Fort van Merksem 2025!'}
                                  body={'Editie 2025 was weer een succes, met dank aan de opkomst van beide clubs. Kon. Sevos TTC wist in drie reeksen de beker te heffen, TTC Bart Merksem won enkel de D-reeks deze keer.'}
                                  date={new Date(2026, 3, 21)}
                    />
                    <Announcement title={'Erkende sportclub!'}
                                  body={'Vanaf juli 2023 is TTC Bart Merksem erkend als sportclub door de Stad Antwerpen! Dat wil zeggen dat we hun veiligheidsscan hebben doorlopen en hun waardeverklaringen hebben ondertekend. Op onze toog kan je nu het “erkende sportclub”-bordje zien staan.'}
                                  date={new Date(2023, 8, 31)}/>
                    <Announcement title={'Vernieuwde site!'}
                                  body={'Welkom op onze nieuwe site. Mocht u nog problemen hebben mag u altijd onze webmaster contacteren ( biemansbart@... ). Vervang de ... door gmail.com ( dit om automatische spam te vermijden )'}
                                  date={new Date(2021, 7, 21)}/>
                </section>

                <aside className={'ttc-aside'}>
                    <div className={'ttc-fb-card'}>
                        <div className={'ttc-fb-head'}>
                            <img className={'ttc-fb-thumb'} src={'/board.jpg'} alt={'Clubfoto'}/>
                            <div className={'ttc-fb-id'}>
                                <a className={'ttc-fb-name'} href={facebookPage} target={'_blank'}
                                   rel={'noreferrer'}>TTC Bart Merksem</a>
                                <div className={'ttc-fb-meta'}>Volg ons op Facebook</div>
                            </div>
                        </div>
                        <div className={'ttc-fb-actions'}>
                            <a className={'ttc-chip'} href={facebookPage} target={'_blank'} rel={'noreferrer'}>Volgen</a>
                            <a className={'ttc-chip'}
                               href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(facebookPage)}`}
                               target={'_blank'} rel={'noreferrer'}>Delen</a>
                        </div>
                        <div className={'ttc-fb-feed'}>
                            <iframe title={'facebook'}
                                    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FTTCBartMerksem&tabs=timeline&width=320&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId=2817641565220366"
                                    style={{border: 'none', overflow: 'hidden'}} frameBorder="0"
                                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"/>
                        </div>
                    </div>
                </aside>
            </div>
        </>
    )
}
